import SelectOption from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  // columns不再用 可删除
  const columns = [
    {
      name: 'id',
      columnProps: {
        label: '审核单ID',
        prop: 'id',
        width: 110,
      },
      render: ({ row }) => {
        return this.$createElement('span', {
          class: this.judgePermission('carAuditRecordDetail') && 'td-canclick',
          on: {
            click: () => { this.judgePermission('carAuditRecordDetail') && this.goOutInDetails(row) },
          },
        }, row.id)
      },
    },
    {
      name: 'type',
      columnProps: {
        label: '审核类型',
      },
      getText: ({ row }) => SelectOption.carExamineTypeDict[row.type],
    },
    {
      name: 'carId',
      columnProps: {
        label: '车辆ID',
        prop: 'carId',
      },
    },
    {
      name: 'carModelName',
      columnProps: {
        label: '车型',
        prop: 'carModelName',
        width: 160,
      },
    },
    {
      name: 'plateNo',
      columnProps: {
        label: '车牌号',
        prop: 'plateNo',
        width: 100,
      },
    },
    {
      name: 'vin',
      columnProps: {
        label: 'VIN码',
        prop: 'vin',
        width: 180,
      },
    },
    {
      name: 'engineNo',
      columnProps: {
        label: '发动机号',
        prop: 'engineNo',
        width: 140,
      },
    },
    {
      name: 'carState',
      columnProps: {
        label: '车辆状态',
      },
      getText: ({ row }) => this.carStateList[row.carState] || row.carState,
    },
    {
      name: 'gmtCreate',
      columnProps: {
        label: '提交审核时间',
        prop: 'gmtCreate',
        width: 160,
      },
    },
    {
      name: 'createUserName',
      columnProps: {
        label: '提交人',
        prop: 'createUserName',

      },
    },
    {
      name: 'state',
      columnProps: {
        label: '审核状态',
      },
      getText: ({ row }) => SelectOption.carExamineState[row.state],
    },
    {
      name: 'gmtModified',
      columnProps: {
        label: '审核完成时间',
        prop: 'gmtModified',
        width: 160,
      },
    },
    {
      name: 'modifiedUserName',
      columnProps: {
        label: '审核人',
        prop: 'modifiedUserName',
      },
    },
    {
      name: 'remark',
      columnProps: {
        label: '驳回理由',
        prop: 'remark',
      },
    },
  ]

  const purchaseInfoColumns = [
    {
      name: 'carId',
      columnProps: {
        label: '车辆ID',
        prop: 'carId',
      },
      render: ({ row }) => {
        return this.$createElement('a', {
          attrs: {
            href: 'javascript:void(0)',
          },
          on: {
            click: () => { this.handelClick({ key: 'carId', value: row.carId }) },
          },
        }, row.carId)
      },
    },
    {
      name: 'plateNo',
      columnProps: {
        label: '车牌号',
        prop: 'plateNo',
        width: 100,
      },
    },
    {
      name: 'modelName',
      columnProps: {
        label: '车型信息',
        prop: 'modelName',
      },
    },
    {
      name: 'carStatus',
      columnProps: {
        label: '是否退车',
      },
      getText: ({ row }) => SelectOption.isWhetherList[row.carStatus],
    },
    {
      name: 'orderId',
      columnProps: {
        label: '采购订单ID',
        prop: 'orderId',
      },
      render: ({ row }) => {
        return this.$createElement('a', {
          attrs: {
            href: 'javascript:void(0)',
          },
          on: {
            click: () => { this.handelClick({ key: 'orderId', value: row.orderId }) },
          },
        }, row.orderId)
      },
    },
    {
      name: 'orderState',
      columnProps: {
        label: '采购订单状态',
      },
      getText: ({ row }) => SelectOption.orderStateList[row.orderState],
    },

    {
      name: 'createTime',
      columnProps: {
        label: '采购订单创建时间',
        prop: 'createTime',
        width: 140,
      },
    },
    {
      name: 'customerName',
      columnProps: {
        label: '车源方名称',
        prop: 'customerName',
      },
    },
    {
      name: 'purchaseType',
      columnProps: {
        label: '采购类型',
      },
      getText: ({ row }) => SelectOption.purchaseType[row.purchaseType],
    },
  ]

  const importHistoryColumns = [
    {
      name: 'uploadDate',
      columnProps: {
        label: '上传日期',
        prop: 'uploadDate',

      },
    },
    {
      name: 'createUser',
      columnProps: {
        label: '操作人名称',
        prop: 'createUser',
      },
    },
    {
      name: 'userAccount',
      columnProps: {
        label: '操作人账号',
        prop: 'userAccount',
      },
    },
    {
      name: 'type',
      columnProps: {
        label: '字段',
      },
      getText: ({ row }) => SelectOption.taskType[row.type],
    },
    {
      name: 'state',
      columnProps: {
        label: '导入状态',
      },
      getText: ({ row }) => SelectOption.importStatus[row.state],
    },
    {
      name: 'operate',
      columnProps: {
        label: '错误说明',
        width: 240,
      },
      maxShowLength: operateMaxShowLength,
      render: ({ row }) => {
        const flag = [4, 5].includes(row.state) && row.resultInfo === '错误详情'
        return this.$createElement('el-button', {
          props: {
            type: 'text',
            size: 'small',

          },
          style: {
            color: flag
              ? ''
              : '#606266',
          },
          on: {
            click: () => {
              // eslint-disable-next-line no-unused-expressions
              flag
                ? this.setRowId(row.id)
                : ''
            },
          },
        }, row.resultInfo)
      },
    },
  ]

  const employeeRoleColumns = [
    {
      name: 'name',
      columnProps: {
        label: '角色名称',
        prop: 'name',

      },
    },
    {
      name: 'remark',
      columnProps: {
        label: '角色描述',
        prop: 'remark',
      },
    },
    {
      name: 'userCount',
      columnProps: {
        label: '员工数量',
        prop: 'userCount',
      },
    },
    {
      name: 'gmtCreate',
      columnProps: {
        label: '创建时间',
        prop: 'gmtCreate',
      },
    },
    {
      name: 'createUser',
      columnProps: {
        label: '创建人',
        prop: 'createUser',
      },
    },
    {
      name: 'gmtModified',
      columnProps: {
        label: '最后更新时间',
        prop: 'gmtModified',
      },
    },
    {
      name: 'modifiedUser',
      columnProps: {
        label: '最后更新人',
        prop: 'modifiedUser',
      },
    },
  ]

  const systemEmployeeAccountColumns = [
    {
      name: 'id',
      columnProps: {
        label: '员工ID',
        width: '150',
      },
      render: ({ row }) => {
        const btns = []
        btns.push(
          this.$createElement('el-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.detailDiglog(row)
              },
            },
          }, row.id),
        )
        return btns
      },
    },
    {
      name: 'userAccount',
      columnProps: {
        label: '账户名称',
        prop: 'userAccount',

      },
    },
    {
      name: 'userMobile',
      columnProps: {
        label: '手机号',
        prop: 'userMobile',
        width: 110,
      },
    },
    {
      name: 'mail',
      columnProps: {
        label: '邮箱',
        prop: 'mail',
      },
    },
    {
      name: 'userName',
      columnProps: {
        label: '员工姓名',
        prop: 'userName',
        width: 140,
      },
    },
    {
      name: 'state',
      columnProps: {
        label: '账号状态',
      },
      getText: ({ row }) => this.accountStateDict[row.state],
    },
    {
      name: 'roleList',
      columnProps: {
        label: '所属角色',
      },
      getText: ({ row }) => (row.roleList.length !== 0 ? row.roleList[0].name : '--'),
    },
  ]

  const serverProviderManageColumns = [
    {
      name: 'id',
      columnProps: {
        label: '服务商ID',
      },
      render: ({ row }) => {
        const btns = []
        if (this.judgePermission('purchase_new_provider_list_detail')) {
          btns.push(
            this.$createElement('el-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.detailDialog(row)
                },
              },
            }, row.id),
          )
        } else {
          btns.push(
            this.$createElement('span', row.id),
          )
        }
        return btns
      },
    },
    {
      name: 'name',
      columnProps: {
        label: '服务商名称',
        prop: 'name',

      },
    },
    {
      name: 'serviceType',
      columnProps: {
        label: '服务商类型',
      },
      getText: ({ row }) => SelectOption.serviceProviderTypeDict[row.serviceType],
    },
    {
      name: 'address',
      columnProps: {
        label: '地址',
        prop: 'address',
      },
    },
    {
      name: 'contacts',
      columnProps: {
        label: '联系人',
        prop: 'contacts',
      },
    },
    {
      name: 'contactTel',
      columnProps: {
        label: '联系方式',
        prop: 'contactTel',
        width: 110,
      },
    },
    {
      name: 'state',
      columnProps: {
        label: '服务商状态',
      },
      getText: ({ row }) => this.accountStateDict[row.state],
    },
    {
      name: 'expireDate',
      columnProps: {
        label: '服务到期时间',
        prop: 'expireDate',
      },
    },
  ]


  this.$nextTick(() => {
    serverProviderManageColumns.push(
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        render: ({ row }) => {
          const btns = []
          if (this.judgePermission('purchase_new_provider_list_edit') && Number(row.supportUpdate) === 1) {
            btns.push(
              this.$createElement('el-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.editHandle(row)
                  },
                },
              }, '编辑'),
            )
          }
          // state 服务商状态(枚举 0禁用 1启用)
          if (this.judgePermission('purchase_new_provider_list_enable_and_disable') && Number(row.state) === 1 && Number(row.supportUpdate) === 1) {
            btns.push(
              this.$createElement('el-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.startStopHandle('disable', row)
                  },
                },
              }, '禁用'),
            )
          }
          if (this.judgePermission('purchase_new_provider_list_enable_and_disable') && Number(row.state) === 0 && Number(row.supportUpdate) === 1) {
            btns.push(
              this.$createElement('el-button', {
                props: {
                  type: 'text',
                },
                on: {
                  click: () => {
                    this.startStopHandle('enable', row)
                  },
                },
              }, '启用'),
            )
          }
          return btns
        },
      },
    )
  })

  return {
    columns,
    purchaseInfoColumns,
    importHistoryColumns,
    employeeRoleColumns,
    serverProviderManageColumns,
    systemEmployeeAccountColumns,
  }
}
